import Vue from 'vue'
import Router from 'vue-router'
import Login from "./pages/Login";
import MainLayout from "./components/layout/MainLayout";
import Dashboard from "./pages/Dashboard";
// import Profile from "./pages/Profile";
import NotFound404 from "./components/layout/NotFound404";
import Users from "./pages/Users/Users";
import UserForm from "./pages/Users/UserForm";
import Customers from "./pages/Customers/Customers";
import CustomerForm from "./pages/Customers/CustomerForm";
import CheckSheetWizardForm from "./pages/CheckSheet/CheckSheetWizardForm";
import CheckSheet from "./pages/CheckSheet/CheckSheet";
import InterventionReport from "./pages/InterventionReports/InterventionReport";
import InterventionReportWizardForm from "./pages/InterventionReports/InterventionReportWizardForm";
import CheckSheetOffline from "./pages/CheckSheet/CheckSheetOffline";
import InterventionReportOffline from "./pages/InterventionReports/InterventionReportOffline";
import Settings from "./pages/Settings";
import CheckSheetOfflineSaved from "./pages/CheckSheet/CheckSheetOfflineSaved";
import InterventionReportOfflineSaved from "./pages/InterventionReports/InterventionReportOfflineSaved";

const guardAuthService = async (to, from, next) => {
    try {
        let token = localStorage.getItem('token')
        if (token && token !== '') {
            next()
        } else {
            next({
                name: 'login',
                // query: {redirectFrom: to.fullPath}
            })
        }
    } catch (e) {
        next({
            name: 'login',
            // query: {redirectFrom: to.fullPath}
        })
    }
};
Vue.use(Router)
export default new Router({
    mode: 'hash',
    base: window.location.pathname,
    routes: [
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            // app route
            path: '/',
            component: MainLayout,
            beforeEnter(to, from, next) {
                guardAuthService(to, from, next);
            },
            children: [
                {
                    path: '',
                    name: 'dashboard',
                    component: Dashboard
                },{
                    path: '/calendar',
                    beforeEnter(to, from, next) {
                        window.open("http://italia.schneeberger.ch", "_blank");
                    }
                }, {
                    path: '/users',
                    name: 'users',
                    component: Users
                }, {
                    path: '/users/:id',
                    name: 'user',
                    component: UserForm
                }, {
                    path: '/settings',
                    name: 'settings',
                    component: Settings
                }, {
                    path: '/customers',
                    name: 'customers',
                    component: Customers
                }, {
                    path: '/customers/:id',
                    name: 'customer',
                    component: CustomerForm
                }, {
                    path: '/checksheet',
                    name: 'checksheet',
                    component: CheckSheet
                }, {
                    path: '/checksheet-offline',
                    name: 'checksheetoffline',
                    component: CheckSheetOffline
                }, {
                    path: '/checksheet-offline-saved',
                    name: 'checksheetofflinesaved',
                    component: CheckSheetOfflineSaved
                }, {
                    path: '/checksheet-wizard',
                    name: 'checksheetwizard',
                    component: CheckSheetWizardForm
                }, {
                    path: '/interventionreport',
                    name: 'interventionreport',
                    component: InterventionReport
                }, {
                    path: '/interventionreport-wizard',
                    name: 'interventionreportwizard',
                    component: InterventionReportWizardForm
                }, {
                    path: '/interventionreport-offline',
                    name: 'interventionreportoffline',
                    component: InterventionReportOffline
                }, {
                    path: '/interventionreport-offline-saved',
                    name: 'interventionreportofflinesaved',
                    component: InterventionReportOfflineSaved
                }
            ]
        }, {
            // not found page
            path: '*',
            redirect: '/'
        }
    ]
})
